
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ExamV2Custom,
  StructExamScoreConfig,
  Vir
} from "@/lib/model/exambuilder/exam-v2";
import AllList from "./all-list.vue";

@Component({
  components: { AllList }
})
export default class Config extends Vue {
  @Prop() exam!: ExamV2Custom;
  open = false;
  // 需要拉数据的接口  在这个文件里做，分配到各个子组件

  created() {
    //
  }
  mounted() {
    // console.log(a);
  }

  ok() {
    this.change();
    this.close();
  }
  close(p?: any) {
    this.open = false;
  }
  //新建时 缓存输入数据
  change() {
    this.$emit("change");
  }
  // 禹霖 *********************************************
  // yours code here

  //****** end ******

  // 翊彭 *********************************************

  //****** end ******
}
